import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPriorityExclamationSign = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11.2 15.6V11h2v4.5h-2zm2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.2 3 2 21.6h20.4L12.2 3zM19 19.6H5.4l6.8-12.4L19 19.6z",
		clipRule: "evenodd"
	})]
});
export default SvgPriorityExclamationSign;
